import type { PropsWithChildren, ReactNode } from "react"

export function Drawer({
  title,
  open,
  onClose,
  subtitle,
  footer,
  widthClassName = "w-full sm:w-[min(760px,100vw)]",
  children,
}: PropsWithChildren<{
  title: string
  open: boolean
  onClose: () => void
  subtitle?: string
  footer?: ReactNode
  widthClassName?: string
}>) {
  if (!open) return null

  return (
    <div className="fixed inset-0 z-50 flex justify-end bg-slate-900/50 backdrop-blur-sm">
      <button
        aria-label="Close drawer"
        className="absolute inset-0 border-0 bg-transparent cursor-default"
        onClick={onClose}
        type="button"
      />
      <aside
        className={`relative z-10 flex h-full ${widthClassName} flex-col bg-white shadow-2xl`}
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <div className="sticky top-0 z-10 flex items-center justify-between border-b border-slate-200 bg-white px-4 py-4 sm:px-6">
          <div>
            <h2 className="text-lg font-semibold text-slate-800">{title}</h2>
            {subtitle ? <p className="mt-1 text-sm text-slate-500">{subtitle}</p> : null}
          </div>
          <button
            className="text-slate-400 hover:text-slate-600 text-sm font-medium"
            onClick={onClose}
            type="button"
          >
            Close
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4 sm:p-6">{children}</div>
        {footer ? (
          <div className="admin-safe-bottom border-t border-slate-200 bg-white px-4 py-4 sm:px-6">
            {footer}
          </div>
        ) : null}
      </aside>
    </div>
  )
}
